var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F15353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47619 9.56028L7.20952 4H8.80952L8.52381 9.56028H7.47619ZM8.00952 12C7.4381 12 7 11.7277 7 11.4099C7 11.0809 7.4381 10.8312 8.00952 10.8312C8.58095 10.8312 9 11.0809 9 11.4099C9 11.7277 8.58095 12 8.00952 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRed);
export default __webpack_public_path__ + "static/media/alert-red.d06e0aa7f7aa9c926a5e3cec7aa093c1.svg";
export { ForwardRef as ReactComponent };